import { Input, Icon } from '@getsynapse/design-system';

interface TeamNameEditInputProps {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  maxLength?: number;
}

export const TeamNameEditInput = ({
  value,
  onChange,
  onSave,
  onCancel,
  maxLength,
}: TeamNameEditInputProps) => {
  return (
    <div className='flex items-center w-full gap-2'>
      <Input
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value)
        }
        onFocus={(e: React.FocusEvent<HTMLInputElement>) => e.target.select()}
        maxLength={maxLength}
        className='w-full'
        aria-label='Edit team name'
        autoFocus
        data-testid='team-name-input'
      />
      <button
        type='button'
        aria-label='Save team name'
        data-testid='team-name-save'
        onClick={onSave}
        className='flex items-center justify-center w-6 h-6 rounded bg-neutral-black text-neutral-white shrink-0'
      >
        <Icon name='checkmark-outline' className='text-base' />
      </button>
      <button
        type='button'
        aria-label='Cancel rename'
        data-testid='team-name-cancel'
        onClick={onCancel}
        className='flex items-center justify-center w-6 h-6 rounded text-neutral-dark hover:bg-neutral-lighter shrink-0'
      >
        <Icon name='close' className='text-base' />
      </button>
    </div>
  );
};
